module.exports = __webpack_public_path__ + "assets/img/my-vpp-btn.87f93977.png";